import api from '../../fetch/api'
export default {
  data () {
    return {
      params: {
        platform: 'browser',
        keycode: 'QRCODE'
      }
    }
  },
  mounted () {
    this.init()
  },

  methods: {
    init () {
      if (/MicroMessenger/.test(window.navigator.userAgent)) {
        //微信内打开：进小程序码长按识别页
        this.params.platform = "weixin";
        this.saveVistRecord();
        window.location.href = '/#/wechat';
      } else if (/AlipayClient/.test(window.navigator.userAgent)) {
        this.params.platform = "alipay";
        this.saveVistRecord();
        window.location.href = '/#/alipay';
      } else {
        //相机、浏览器等其他软件：引导页提示改用微信扫一扫
        this.params.platform = "browser";
        this.saveVistRecord();
        window.location.href = '/#/browser';
      }
    },
    // 访问统计上报：gcx-realtime-bus /appApi/statistics/h5Visit（原 /api/miniprogram 接口已死，勿改回）
    saveVistRecord () {
      api.h5VisitReport(this.params).then(res => {
      }).catch(err => {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/miniUrl/miniQrcode.js